<template>
  <div class="loading-statistic-result">
    <div class="loading-statistic-card__card-info bg-card">
      <div
        class="loading-statistic-card__card-info-count-available-results field-darker field-1"
      />
      <div class="loading-statistic-card__card-info-text-content">
        <div class="field-smooth field-2" />
        <div class="field-darker field-3" />
      </div>
      <div class="loading-statistic-card__card-info-icon-content">
        <p class="field-smooth field-4" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResultCardLoading'
}
</script>

<style lang="scss" scoped>
.loading-statistic-result {
  flex: 1;
  max-width: 350px;
  .bg-card {
    border-radius: 6px;
    background-color: #ffffff;
    animation: loading 1.5s infinite;
    background-position: -400px;
    background-size: 100% 100%;
    background-image: linear-gradient(
      90deg,
      hsla(0, 20%, 97.1%, 0.4),
      hsla(0, 2.1%, 62.7%, 0.2) 50%,
      hsl(0, 0%, 100%)
    );
    background-repeat: no-repeat;
  }

  .loading-statistic-card {
    &__card-info {
      background-color: white;
      padding: 12px;
      border-radius: 5px;
      margin-left: 15px;
      display: flex;
      cursor: progress;

      &-count-available-results {
        padding: 12px;
        border-radius: 5px;
        margin: auto;
      }

      &-text-content {
        padding: 5px;
        line-height: 16px;
        margin-top: auto;
        margin-left: 0.5em;
        flex: 1;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-content: baseline;
        flex-direction: column;
      }
    }
  }

  .field {
    &-smooth {
      height: 12px;
      opacity: 0.1;
      border-radius: 3px;
      background-color: #858585;
    }
    &-darker {
      margin-top: 10px;
      height: 14px;
      opacity: 0.1;
      border-radius: 3px;
      background-color: #111111;
    }
    &-1 {
      height: 44px;
      width: 35px;
    }
    &-2 {
      width: 50%;
    }
    &-3 {
      width: 100%;
    }
    &-4 {
      width: 30px;
      height: 30px;
      border-radius: 100%;
      margin-top: 10px;
    }
  }

  @keyframes loading {
    to {
      background-position: 400px;
    }
  }
}
</style>
